import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { watch, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
const __default__ = {
  name: "App"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const styleObj = computed(() => {
      return {
        height: "100%"
      };
    });
    const store = useStore();
    const debounce = (fn, delay) => {
      let timer = null;
      return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      };
    };
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
      constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
      }
    };
    onMounted(() => {
      window.onbeforeunload = e => {
        if (e) {
          return;
        }
      };
    });
    onUnmounted(() => {
      window.onbeforeunload = null;
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        id: "app",
        style: _normalizeStyle(_unref(styleObj))
      }, [_createVNode(_component_router_view)], 4);
    };
  }
});